import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { CommonService } from 'src/app/core/services/common.service';
import { BranchService } from 'src/app/core/services/branch.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';

declare function registerCustomerAutoComplete(listener): any;
declare function registerBranchAutoComplete(listener): any;
declare function bindData(formData): any;
declare function bindAutofillDataJ(data, overWrite): any;
declare function getDocumentFormJsonDataJ(callback, toastr, panelData): any;
declare function hideForm(): any;
declare function showForm(): any;

enum AutoCompletedType {
  AllBranchesAndParentEnterprises
}

@Component({
  selector: 'app-display-template',
  templateUrl: './display-template.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class DisplayTemplateComponent implements OnInit, AfterViewInit, OnDestroy {

  documentTemplate = '';

  /**
   * Create new instance.
   * @param commonService the common service
   * @param enterpriseService the enterprise service
   */
  constructor(
    private commonService: CommonService,
    private branchService: BranchService,
    private customerService: CustomerService) { }

  /**
   * On init
   */
  ngOnInit() { }

  /**
   * After view has been inited
   */
  ngAfterViewInit() { }

  /**
   * On destroy component
   */
  ngOnDestroy() {
  }

  /**
   * Change document template.
   * @param template The document template.
   */
  public onChangeTemplate(template) {
    this.documentTemplate = template;
    /**
     * C� th? kh�ng d�ng
     * */
    // Pass autocomplete method processing to jquery.
    registerCustomerAutoComplete((term, callbackRespone) => {
      this.commonService.getCustomers(term).subscribe(async res => {
        if (!res || !res.data) {
          return;
        }
        // Autocompleted customers api only get id and name of customer, now call to the detail customer api
        const shortCustomersInfoArray: [] = res.data;
        const observables: any[] = [];
        shortCustomersInfoArray.forEach((customer: any) => {
          if (customer.id) {
            observables.push(this.customerService.getCustomer1(customer.id));
          }
        });
        // Since backend system does not include detail information of the customer, foreach customer in the autocompeleted
        // result, call to the customer detail api
        Observable.forkJoin(observables).subscribe((dataArray: any) => {
          const customers = [];
          dataArray.forEach((customer) => {
            if (!customer.data) {
              return;
            }
            customers.push(customer.data);
          });
          callbackRespone(customers);
        });
      });
    });
    /**
     * C� th? kh�ng d�ng
     * */
    // pass autocomplete method processing to jquery.
    // registerBranchAutoComplete((term, callbackRespone) => {
    //   this.branchService.getAllBranchesAndParentEnterprises(localStorage.getItem('enterpriseId')).subscribe(res => {
    //     if (res.data) {
    //       // call back process.
    //       callbackRespone(res.data);
    //     }
    //   });
    // });

    hideForm();
    showForm();
  }

  /**
   * Bind data of document to the template
   */
  public bindDataToTemplate(documentData) {
    bindData(documentData);
  }

  /**
   *  bindAutofillData
   */
  public bindAutofillData(data: any, overWrite: boolean) {
    bindAutofillDataJ(data, overWrite);
  }

  /**
   * get document from json data.
   */
  public getDocumentFormJsonData(callback, toastr, panelData) {
    return getDocumentFormJsonDataJ(callback, toastr, panelData);
  }
}
